import React from 'react';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import { BEACON_SUBTABS, BEACON_TABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';
import colors from 'src/utils/colors';
import { useContentGenerationStore } from '../Generate/components/ProductTable/store';
import { useProjects } from './hooks/useProjects';

export const AddProjectButton: React.FC = () => {
  const { beaconNavigator } = useBeaconNavigator();
  const { clearSelection } = useContentGenerationStore();
  const { clearProjectFlow } = useProjects();

  const handleClick = () => {
    clearSelection();
    clearProjectFlow();
    beaconNavigator.updateSearchParams({ 
      tab: BEACON_TABS.PROJECTS, 
      subtab: BEACON_SUBTABS.PROJECTS_SETTINGS 
    });
    beaconNavigator.go();
  };

  return (
    <SlButton
      onClick={handleClick}
      textSx={{ color: 'white' }}
      buttonSx={{
        backgroundColor: colors.darkBlue,
        borderRadius: '4px',
        border: `1px solid ${colors.darkBlue}`,
        padding: '0 20px',
        '&:hover': {
          backgroundColor: '#68727C',
          border: '1px solid #68727C'
        }
      }}
    >
      + Add Project
    </SlButton>
  );
};

